import {provide, ref, useTemplateRef, watch} from 'vue';
import {collapseContextKey, CHANGE_EVENT, UPDATE_MODEL_EVENT} from './constants';
import {ensureArray} from './ensureArray';

const scrollToTop = (id, scrollOffset, accordion, duration) => {
  const collapseItem = document.getElementById(`pdl-collapse-item-${id}`);
  const offset = Math.abs(scrollOffset);
  const scrollBehavior = !window.matchMedia(`(prefers-reduced-motion: reduce)`).matches ? 'smooth' : 'instant';
  const scrollToElement = () => {
    window.scrollTo({
      top: collapseItem.getBoundingClientRect().top + window.scrollY - offset,
      behavior: scrollBehavior,
    });
  };

  if (accordion) {
    //timeout needed to allow previous collapse item to close
    setTimeout(() => {
      scrollToElement();
    }, duration);
  } else {
    scrollToElement();
  }
};

export const useCollapse = (props, emit) => {
  const activeNames = ref();
  const collapseContainer = useTemplateRef('collapseContainer');

  if (props.modelValue.length < 1) {
    activeNames.value = [];
  } else {
    activeNames.value = ensureArray(props.modelValue);
  }

  const setActiveNames = (_activeNames) => {
    activeNames.value = _activeNames;
    const value = props.accordion ? activeNames.value[0] : activeNames.value;

    emit(UPDATE_MODEL_EVENT, value);
    emit(CHANGE_EVENT, value);
  };

  const handleItemClick = (name, id) => {
    if (props.accordion) {
      setActiveNames([activeNames.value[0] === name ? '' : name]);
    } else {
      const _activeNames = [...activeNames.value];
      const index = _activeNames.indexOf(name);

      if (index > -1) {
        _activeNames.splice(index, 1);
      } else {
        _activeNames.push(name);
      }
      setActiveNames(_activeNames);
    }
    if (props.isScrollToTop) {
      scrollToTop(id, props.scrollToTopOffset, props.accordion, props.scrollDuration);
    }
  };

  watch(
    () => props.modelValue,
    () => (activeNames.value = ensureArray(props.modelValue)),
    {deep: true}
  );

  provide(collapseContextKey, {
    activeNames,
    handleItemClick,
    collapseContainer,
    props,
  });
  return {
    activeNames,
    setActiveNames,
    collapseContainer,
  };
};
